import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "autosave" }
const _hoisted_2 = { class: "badge-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Badge = _resolveComponent("Badge")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.valid)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "badge-text" }, "Fix errors on the page to save", -1 /* HOISTED */)),
          _createVNode(_component_Badge, {
            error: "",
            class: "badge",
            icon: "save-01"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Cannot save")
            ])),
            _: 1 /* STABLE */
          })
        ], 64 /* STABLE_FRAGMENT */))
      : ($props.saving)
        ? (_openBlock(), _createBlock(_component_Badge, {
            key: 1,
            success: "",
            class: "save",
            icon: "refresh-cw-09"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Saving")
            ])),
            _: 1 /* STABLE */
          }))
        : ($props.saved_at)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString($data.saved_ago), 1 /* TEXT */),
              _createVNode(_component_Badge, {
                success: "",
                class: "badge",
                icon: "save-01"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Saved")
                ])),
                _: 1 /* STABLE */
              })
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
  ]))
}